import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Images from "../../utils/Images";

export default function LoadingScreen({ onComplete }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onComplete?.(), 800);
    }, 7000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="flex overflow-hidden fixed inset-0 justify-center items-center w-full h-full bg-gradient-to-br from-[#093B0C] via-[#07450B] to-[#07560C]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex absolute inset-0 justify-center items-center">
            <motion.div
              className="absolute w-[868px] h-[868px] rounded-full bg-[#07450B]"
              animate={{
                scale: [1, 1.1, 1],
                opacity: [0.8, 1, 0.8],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: 0,
                ease: "easeInOut",
              }}
            />

            <motion.div
              className="absolute w-[868px] h-[868px] rounded-full bg-[#07450B]"
              animate={{
                scale: [1, 1.1, 1],
                opacity: [0.8, 1, 0.8],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: 0.6,
                ease: "easeInOut",
              }}
            />

            <motion.div
              className="absolute w-[632px] h-[632px] rounded-full bg-[#07560C]"
              animate={{
                scale: [1, 1.1, 1],
                opacity: [0.8, 1, 0.8],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: 1.2,
                ease: "easeInOut",
              }}
            />

            <motion.div
              className="absolute w-[480px] h-[480px] rounded-full bg-[#0D6813]"
              animate={{
                scale: [1, 1.1, 1],
                opacity: [0.8, 1, 0.8],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: 1.8,
                ease: "easeInOut",
              }}
            />

            <motion.div
              className="absolute w-[297px] h-[297px] rounded-full bg-[#0D8816]"
              animate={{
                scale: [1, 1.1, 1],
                opacity: [0.8, 1, 0.8],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: 2.4,
                ease: "easeInOut",
              }}
            />
          </div>

          <div className="flex relative z-10 justify-center items-center">
            <motion.div
              className="flex gap-4 items-center"
              initial={{ scale: 0.8, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 0.8, ease: "easeOut" }}
            >
              <motion.div
                className="relative w-52 h-52"
                animate={{
                  rotate: [0, 5, -5, 0],
                  scale: [1, 1.05, 1],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                <img
                  src={Images.logo_white}
                  alt="white logo"
                  className="object-contain w-full h-full"
                />
              </motion.div>
            </motion.div>
          </div>

         
          <motion.div
            className="flex absolute top-[55%] left-[48%] z-20 gap-2 translate-y-8 sm:gap-3 md:gap-4 lg:gap-2"
            style={{
              left: 'clamp(30%, 48%, 48%)',
              top: 'clamp(50%, 55%, 55%)'
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 2.5 }}
          >
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                className="w-2 h-2 rounded-full bg-white/60 sm:w-3 sm:h-3 md:w-4 md:h-4 lg:w-2 lg:h-2"
                animate={{
                  scale: [1, 1.5, 1],
                  opacity: [0.6, 1, 0.6],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  delay: i * 0.2,
                  ease: "easeInOut",
                }}
              />
            ))}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
